// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const dashboardSelectionOrderValues = [1, 2, 3, 4, 5, 6];

export const dashboardSelectionOptions = [
    { value: 'devicedetails', label: 'Devices Details Tables' },
    { value: 'devusage', label: 'Device Usage' },
    { value: 'devicetypes', label: 'Devices by OS and Type' },
    { value: 'psactivity', label: 'Power State Activity' },
    { value: 'batterycap', label: 'Battery Charge Capacity' },
    { value: 'devicesVtime', label: 'Devices vs Time' }
];

export const timeIntervals = [
    { value: 60, label: '1 minute' },
    { value: 300, label: '5 minutes' },
    { value: 600, label: '10 minutes' },
    { value: 900, label: '15 minutes' },
    { value: 1200, label: '20 minutes' },
    { value: 1800, label: '30 minutes' },
    { value: 2700, label: '45 minutes' },
    { value: 3600, label: '60 minutes' },
    { value: 7200, label: '2 hours' },
    { value: 10800, label: '3 hours' },
    { value: 14400, label: '4 hours' },
    { value: 18000, label: '5 hours' },
    { value: 21600, label: '6 hours' },
    { value: 25200, label: '7 hours' },
    { value: 28800, label: '8 hours' },
    { value: 0, label: 'Never' }
];

export const availableOptions = [
    { value: 1, label: 'Enabled' },
    { value: 0, label: 'Disabled' }
];

export const eventOptions = [
    { value: 'wake', label: 'Wake' },
    { value: 'sleep', label: 'Sleep' },
    { value: 'shutdown', label: 'ShutDown' },
    { value: 'restart', label: 'Restart' }
    // { value: 'rename', label: 'Rename' },
    // { value: 'schedule', label: 'Schedule' }
];

export const deviceColumnOptions = [
    { value: 'name', label: 'Device Name' },
    { value: 'mac', label: 'MAC Address' },
    { value: 'ipv4', label: 'IP Address' },
    { value: 'os_ver', label: 'OS Version' },
    { value: 'os_name', label: 'OS Name' },
    { value: 'proc', label: 'Processor' },
    { value: 'sys_type', label: 'System Type' },
    { value: 'disp_1_nm', label: 'Display 1' },
    { value: 'disp_2_nm', label: 'Display 2' },
    { value: 'manufacturer', label: 'Manufacturer' },
    { value: 'version', label: 'Device Version' },
    { value: 'username', label: 'User' },
    { value: 'client_ver', label: 'Client Version' },
    { value: 'lastconnect', label: 'Last Updated' },
    { value: 'islicensed', label: 'Licensed' },
    { value: 'isportable', label: 'Portable' },
    { value: 'currentstate_id', label: 'Current State' },
    { value: 'stateid_id', label: 'Power State' },
    { value: 'devtype_id', label: 'Device Type' },
    { value: 'groupid_id', label: 'Group' },
    { value: 'policyid_id', label: 'Policy' },
    { value: 'label', label: 'Label' },
    { value: 'ldap', label: 'LDAP' }
];

export const backgroundScheme = {
    schemeName: 'Background Scheme',
    schemeDescription: 'Display 15/CPU 30',
    startTime: '00:00:00',
    endTime: '23:59:59',
    days: {
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true
    },
    advancedSettings: {
        brightness: 100,
        cpuInactivityTimeoutAC: 900,
        cpuInactivityTimeoutDC: 900,
        cpuMax: 25,
        diskMax: 25,
        displayInactivityTimeoutAC: 900,
        displayInactivityTimeoutDC: 900,
        hidWake: 0,
        networkMax: 2500,
        screenDim: 100,
        usbSleepAC: 1,
        usbSleepDC: 1,
        wakeTimersAC: 1,
        wakeTimersDC: 1
    }
};

export const upgradeOptions = [
    { id: '0', name: 'Use Rule' },
    { id: 'upgrade', name: 'Upgrade' },
    { id: 'notUpgrade', name: 'Do NOT upgrade' }
];

export const licenseOptions = [
    { id: '0', name: 'Use Rule' },
    { id: 'unlicensed', name: 'Do Not License' },
    { id: 'license', name: 'License' }
];

export const equivalentOptions = [
    { value: 'smartphone', label: 'Smartphones charged in a year' },
    { value: 'carmiles', label: 'Passenger car miles driven in a year' },
    { value: 'gallons', label: 'Gallons of gasoline used in a year' },
    { value: 'houseenergy', label: 'Household electricity for one year' },
    { value: 'oilbarrels', label: 'Barrels of oil consumed in one year' },
    { value: 'coalpounds', label: 'Pounds of coal burned in one year' }
];

export const avoidanceOptions = [
    { value: 'wastetonnage', label: 'Tons of waste recycled' },
    { value: 'bagsoftrash', label: 'Bags of trash recycled' },
    { value: 'turbines', label: 'Wind turbines running for a year' },
    { value: 'ledbulbs', label: 'Old bulbs replaced with LED' }
];

export const sequesteredOptions = [
    { value: 'seedlings', label: 'Tree seedlings grown for 10 years' },
    { value: 'acres', label: 'Acres of US forest' }
];

export const dateRangeOptions = [
    { value: '1week', label: 'One week' },
    { value: '2weeks', label: 'Two weeks' },
    { value: '1month', label: 'One Month' },
    { value: '3months', label: 'Three Months' },
    { value: '6months', label: 'Six Months' },
    { value: '1year', label: 'One Year' },
    { value: '0', label: 'Custom' }
];
